/// <reference path="../../../../../../typings/index.d.ts" />

// Todo: Dev
module Meevo.Plugins.Accountsync {
    'use strict';

    enum SyncScreens {
        PossibleActions,
        InProcess
    }

    enum SyncState {
        NA,
        Sync,
        Delete,
        Success,
        Fail
    }

    interface ILastSync {
        syncDate: Date;
        syncRangeDateStart: Date;
        syncRangeDateEnd: Date;
        syncState: SyncState;
    }

    interface ISyncInformation {
        itemsAdded: number;
        invoices: number;
        creditMemos: number;
        monetaryPayments: number;
        nonMonetaryPayments: number;
        openCloseHistory: number;
        generalJournals: number;
    }

    interface ISyncDate {
        sync: ISyncDateRange;
        deleteSync: ISyncDateRange;
    }

    interface ISyncDateRange {
        from: Date;
        to: Date;
    }

    interface ISyncStatus {
        value: SyncProcessingStatusEnum;
        label: string;
    }

    interface IAccountsyncSyncController {
        latestConnectionId: Guid,
        currentScreen: SyncScreens,
        connectionList: IConnectionListItem[],
        requestData: ISyncRequestData,
        choosedConection: IConnectionListItem,        
        isHideDateLabel: boolean,
        messageLastSyncDate: string,
        messageSyncStatus: string,
        isDeleteSync: boolean,

        syncDates: ISyncDate,
        lastSync: ILastSync,
        syncStatuses: ISyncStatus[],

        startSync: () => void,
        deleteSync: () => void,
        chooseConnection: (applicationConnectionId: Guid) => void,
        validateEditableDates: () => angular.IPromise<boolean>
    }

    class SyncController implements IAccountsyncSyncController {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.modal.ModalService',
            'meevo.components.busy.BusyService',
            'meevo.plugins.accountsync.AccountsyncService',
            '$scope',
            '$translate',
            '$q'
        ];
         
        public latestConnectionId: Guid;
        public currentScreen: SyncScreens = SyncScreens.PossibleActions;
        public connectionList: IConnectionListItem[];
        public requestData: ISyncRequestData;
        public choosedConection: IConnectionListItem;        
        
        public messageLastSyncDate: string;
        public messageSyncStatus: string;

        public isHideDateLabel: boolean = true;
        public isDeleteSync: boolean;
        
        // Todo: Change yesterdayDateFotConference for yesterdayDate after conference
        private yesterdayDate: Date = moment().subtract(1, 'days').toDate();
        private yesterdayDateFotConference: Date = moment().toDate();

        public syncDates: ISyncDate;

        public lastSync: ILastSync = {
            syncDate: new Date(2017, 10, 5),
            syncRangeDateStart: new Date(2017, 10, 1),
            syncRangeDateEnd: new Date(2017, 10, 4),
            syncState: SyncState.Success
        };

        public syncStatuses: ISyncStatus[] = [
            { value: SyncProcessingStatusEnum.Complete, label: 'LABEL_COMPLETED' },
            { value: SyncProcessingStatusEnum.Failed, label: 'LABEL_FAILED' },
            { value: SyncProcessingStatusEnum.InError, label: 'LABEL_ERROR' }
        ];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected accountsyncService: IAccountsyncService,
            protected $scope: angular.IScope,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService ) {            
        }

        $onInit(): void {
            this.$scope.$on('$mdMenuOpen', () => {
                this.stylizationTooltip();
            });

            this.$scope.$on('selectSyncTab', this.initSyncTab.bind(this));
        }

        /**
         * Initialize Sync Tab after opening
         * @param {any} event
         * @param {any} data from event
         */
        initSyncTab(event: any, data: any): void {
            if (data.latestConnectionId) {
                this.latestConnectionId = data.latestConnectionId;                
            }

            this.syncDates = {
                sync: { from: this.yesterdayDateFotConference, to: this.yesterdayDateFotConference },
                deleteSync: { from: this.yesterdayDateFotConference, to: this.yesterdayDateFotConference }
            };

            this.setDefaultConnectionForDropdown();
            this.finish();
        }

        /**
         * Start sync using connection id and date range
         */
        startSync(): void {
            if (!this.isChoosedConnection()) {
                return;
            }

            this.validateEditableDates().then(_ => {
                this.busyService.start();
                let drawerSearchCriteria = {
                    criteria: {
                        startDate: moment(this.syncDates.sync.from).subtract(1, 'months').format('l LT'), //day of one month ago
                        endDate: moment(this.syncDates.sync.to).format('l LT')
                    }
                };
                return this.accountsyncService.getNotClosedDrawersList(drawerSearchCriteria);
            }).then(drawersList => {
                if (drawersList.length) {
                    let options: Meevo.Components.Modal.IModalOptions = {
                        templateUrl: 'app/plugins/accountsync/modal/openedDrawersList.modal.html',
                        controller: 'meevo.plugins.accountsync.OpenedDrawerListController',
                        controllerAs: 'vm',
                        clickOutsideToClose: true,
                        locals: { drawersList: drawersList }
                    };
                    this.modalService.showCustom(options);
                    return this.$q.reject();
                }
                return this.accountsyncService.getTaxStatus({
                    applicationConnectionId: this.choosedConection.applicationConnectionId
                });
            }).then((taxStatus: boolean) => {
                if (!taxStatus) {
                    this.modalService.alert('MESSAGE_ALERT_TAX_MUST_TRNED');
                    return this.$q.reject();
                }
                this.requestData = {
                    id: this.choosedConection.applicationConnectionId,
                    startDate: this.syncDates.sync.from,
                    endDate: this.syncDates.sync.to
                }
                return this.accountsyncService.syncData(this.requestData);                
            }).then(response => {
                this.isDeleteSync = false;
                this.currentScreen = SyncScreens.InProcess;
            }).finally(() => {
                this.busyService.stop();
            });
        }

        /**
         * Delete sync using connection id and date range
         */
        deleteSync(): void {
            if (!this.isChoosedConnection()) {
                return;
            }

            const confirmMessage: string = this.translate('MESSAGE_ACCOUNTSYNC_DELETE_ACCOUNTSYNC_DATA_BEGIN') + ' '
                + moment(this.syncDates.deleteSync.from).format('L') + ' ' + this.translate('LABEL_AND') + ' '
                + moment(this.syncDates.deleteSync.to).format('L') + ' ' + this.translate('MESSAGE_ACCOUNTSYNC_DELETE_ACCOUNTSYNC_DATA_END')

                + ' ' + this.translate('MESSAGE_ACCOUNTSYNC_DELETE_ANY_DEPOSITE');
            this.modalService.confirm(confirmMessage)
                .then((response: boolean) => {
                    this.requestData = {
                        id: this.choosedConection.applicationConnectionId,
                        startDate: this.syncDates.deleteSync.from,
                        endDate: this.syncDates.deleteSync.to
                    }

                    this.busyService.start();
                    return this.accountsyncService.deleteSync(this.requestData);                        
                }).then(response => {
                    this.isDeleteSync = true;
                    this.currentScreen = SyncScreens.InProcess;
                }).finally(() => {
                    this.busyService.stop();
                });;
        }

        /**
         * Choose connection by id and get the last sync data of it
         * @param {Guid} applicationConnectionId
         */
        chooseConnection(applicationConnectionId: Guid): void {
            this.accountsyncService.getLastSyncData(applicationConnectionId)
                .then(response => {               
                    if (response.processingStatus == undefined) {
                        this.messageLastSyncDate = null;
                        this.messageSyncStatus = null;
                    } else {
                        this.messageLastSyncDate = this.$translate.instant('MESSAGE_LAST_SYNC_DATE',
                            {
                                dateCreated: moment(response.dateCreated).format('L'),
                                dateToProcessFrom: moment(response.dateToProcessFrom).format('L'),
                                dateToProcessTo: moment(response.dateToProcessTo).format('L')
                            });    

                        const msg: ISyncStatus = _.find(this.syncStatuses, (item: ISyncStatus) => {
                            return item.value === response.processingStatus;
                        });
                        this.messageSyncStatus = msg.label;
                    }
                }
            );
        }       

        /**
         * Validate editable dates before start sync
         * @returns {angular.IPromise<boolean>} promise
         */
        validateEditableDates(): angular.IPromise<boolean> {
            const sixteenDaysAgo: Date = moment().subtract(16, 'days').toDate();

            if (this.syncDates.sync.to >= sixteenDaysAgo) {
                const confirmMessage: string = this.translate('MESSAGE_ACCOUNTSYNC_DATES_ARE_EDITABLE');
                return this.modalService.confirm(confirmMessage);
            }

            return this.$q((resolve) => {
                resolve(true);
            });
        }

        get syncScreensEnum(): any {
            return SyncScreens;
        }

        get syncStateEnum(): any {
            return SyncState;
        }       

        /**
         * Check if selected connection before start sync
         * @returns {boolean}
         */
        private isChoosedConnection(): boolean {
            if (!this.choosedConection) {
                this.modalService.alert(this.translate('MESSAGE_ALERT_PLEASE_CHOOSE_CONNECTION'));
                return false;
            }
            return true;
        }

        /**
         * Finish actions in Sync Tab
         */
        private finish(): void {
            this.currentScreen = SyncScreens.PossibleActions;
        }

        /**
         * Get 'FROM' date of sync or delete
         * @returns {Date}
         */
        private getFromDate(): Date {
            return this.isDeleteSync ? this.syncDates.deleteSync.from : this.syncDates.sync.from;
        }

        /**
         * Get 'TO' date of sync or delete
         * @returns {Date}
         */
        private getToDate(): Date {
            return this.isDeleteSync ? this.syncDates.deleteSync.to : this.syncDates.sync.to;
        }

        /**
         * Set default connection in dropdown
         */
        private setDefaultConnectionForDropdown(): void {
            if (this.latestConnectionId) {
                this.choosedConection = _.find(this.connectionList, connection => connection.applicationConnectionId === this.latestConnectionId);
            } else {
                this.choosedConection = this.connectionList[0];
            }            

            this.chooseConnection(this.choosedConection.applicationConnectionId);
        }

        /**
         * Translate using key
         * @param {string} key
         * @returns {string}
         */
        private translate(key: string): string {
            return this.$translate.instant(key);
        }

        // Binded methods
        stylizationTooltip(): void { }
    }

    class SyncComponent implements angular.IComponentOptions {
        templateUrl = 'app/plugins/accountsync/components/sync/sync.template.html';
        controller = SyncController;
        controllerAs = 'model';
        bindings: any = {
            connectionList: '=',
            stylizationTooltip: '&'
        };
    }

    angular.module('meevo.plugins.accountsync')
        .component('accountasyncSyncComponent', new SyncComponent());
}